import { render, staticRenderFns } from "./hot-details.vue?vue&type=template&id=5bc6e0d0&scoped=true&"
import script from "./hot-details.vue?vue&type=script&lang=js&"
export * from "./hot-details.vue?vue&type=script&lang=js&"
import style0 from "./hot-details.vue?vue&type=style&index=0&id=5bc6e0d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6e0d0",
  null
  
)

export default component.exports